import React from "react";
import { Link } from "react-router-dom";
import Home from "./theme/Home";

export default function HomeLogin() {
  return (
    <Home
      form={
        <div className="home-links">
          <Link className="btn" to="/login-master">
            I am the team leader
          </Link>
          <Link className="btn" to="/login">
            I'm not the team leader
          </Link>
        </div>
      }
    />
  );
}
